<template>
    <div class="container" v-if="navbarVisible">
        <div class="row">
            <div class="col">
                <div class="user-block">
                    <div class="user-name">
                        {{profile.name}}
                    </div>
                    <a href="javascript:void(0)" @click="logout()" class="logout-link">
                        <i class="fa fa-sign-out"></i>
                    </a>
                </div>
                <ul class="navbar-list">
                    <li>
                        <router-link to="/" :class="getActiveClass('/')">Queue list</router-link>
                    </li>
                    <li>
                        <router-link to="/failed-jobs" :class="getActiveClass('/failed-jobs')">Failed jobs</router-link>
                    </li>
                    <li>
                        <router-link to="/supervisor/dashboard" :class="getActiveClass('/supervisor/dashboard')">Supervisors</router-link>
                    </li>
                    <li>
                        <router-link to="/job-stats/dashboard" :class="getActiveClass('/job-stats/dashboard')">Job Stats</router-link>
                    </li>
                    <li>
                        <router-link to="/users" :class="getActiveClass('/users')">Users</router-link>
                    </li>
                </ul>

            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'Navbar',

        data: function(){
            return {

            }
        },

        mounted(){},

        methods: {
            getActiveClass(path){
                return this.$route.path === path ? { active: true } : { active: false };
            },
            logout(){
                this.$authService.logout();
                this.$router.push("/auth");
            }
        },
        computed: {
            profile: {
                get(){
                    return this.$store.getters.currentUser
                }
            },
            navbarVisible(){
                return !this.$route.meta.hideNavigation;
            }
        }
    }
</script>

<style scoped lang="scss" type="text/scss">

    .navbar-list{
        list-style: none;
        padding: 0;

        border-bottom: 2px solid #bbb;

        li{
            display: inline-block;
            a{
                display: inline-block;
                text-decoration: none;
                padding: 10px;
                border: 2px solid #aaa;
                margin-bottom: -2px;
                color: #888;

                &.router-link-exact-active{
                    border-bottom-color: #fff;
                    color: #222;
                }

                &:hover{
                    color: #222;
                }
            }
        }
    }
    .user-block{
        float: right;
        & > div{
            display: inline-block;
        }
        .logout-link{
            color: #333;
            font-size: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/navbar.component.vue